<template>
    <button class="btn" :class="{loading: props.loading, disabled: props.disabled}" @click="onClick">
        <i v-if="prependIcon" :class="`ti-${prependIcon}`"></i>
        <slot/>
        <i v-if="appendIcon" :class="`ti-${appendIcon}`"></i>
        <common-loader class="any-size fit" v-if="loading"></common-loader>
    </button>
</template>

<script setup lang="ts">

const props = defineProps<{
    disabled?: boolean,
    loading?: boolean,
    prependIcon?: 'string',
    appendIcon?: 'string',
}>();

const emits = defineEmits(['click', 'hover']);

function onClick() {
    if (!props.disabled && !props.loading) {
        emits('click');
    }
}

</script>
